import { CloseCircleOutlined, FormOutlined, RightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Popconfirm } from 'antd';
import { getStoreCount } from 'components/StoreScopes';
import { noop } from 'lodash-es';
import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';

export const Tag = styled.div<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  font-size: 12px;
  color: #515359;
  background: #f0f2f5;
  border-radius: 2px;
  cursor: ${({ disabled = false }) => (disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    color: ${({ disabled = false }) => (disabled ? '#515359' : 'var(--ant-primary-color)')};
  }
  > * + * {
    margin-left: 6px;
  }
  > span > span {
    vertical-align: -2px;
  }
`;

export interface ScopeTagProps extends HTMLAttributes<HTMLDivElement> {
  value?: General.StoreScope[];
  departmentScopes?: General.StoreScope[];
  disabled?: boolean;
  onClear?: () => void;
}

function ScopeTag(props: ScopeTagProps) {
  const {
    value = [],
    departmentScopes = [],
    disabled: disabledProp = false,
    onClear,
    onClick = noop,
    ...otherProps
  } = props;

  const { t } = useTranslate();

  const count = getStoreCount(value);

  const departmentScopesCount = getStoreCount(departmentScopes);

  const isDepartmentAllScopes = value.length === 0 || count === departmentScopesCount;

  const disabled = disabledProp && value.length === 0;

  return (
    <Tag disabled={disabled} onClick={(e) => !disabled && onClick(e)} {...otherProps}>
      <span>
        {isDepartmentAllScopes
          ? t('department.部门全部店铺')
          : t('department.已选x店铺', { x: count })}
      </span>
      {!isDepartmentAllScopes && !disabledProp && onClear ? (
        <span onClick={(e) => e.stopPropagation()}>
          <Popconfirm
            title={t('department.删除后恢复部门默认权限范围，你确定要删除吗？')}
            onConfirm={onClear}
          >
            <CloseCircleOutlined />
          </Popconfirm>
        </span>
      ) : null}
      {!disabledProp && <FormOutlined />}
      {disabledProp && value.length > 0 && <RightOutlined style={{ fontSize: 10 }} />}
    </Tag>
  );
}

export default ScopeTag;
